import { Space } from 'antd';

type ActionsButtonWrapperProps = {
    children: React.ReactNode;
    style?: React.CSSProperties;
};

const FlexInlineStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: "row",
    justifyContent: 'center',
};

export const ActionsButtonWrapper = ({ children, style }: ActionsButtonWrapperProps) => {
    return (
        <Space size="small" wrap style={{
            width: "100%",
            ...FlexInlineStyle,
            ...style
        }}>
            {children}
        </Space>
    );
};
